define(['../appContext', '../utils/tools'],
function (app, tools) {
    "use strict";

    var s = {};

    s.allSecurityGroups = new tools.dictionary();

    s.applyClientProperties = function (entity) {
        if (entity == null) { return; }
        entity.clientProperties = new app.dv.entities.ClientProperties(app.dv.types.EntityTypes.SecurityGroup);
    };

    return s;
});
